import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, dateTimeFormat, dateTimeFormatIOS, formatDateToISO } from 'pages/Common';
import Dropzone from "react-dropzone"
import Compressor from "compressorjs"
import uploadImage from "../../assets/images/uploadImage.png"


const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

const CreateUpdateDrawRequirementModel = ({ modal, toggle, isEdit, editData, DrawRequirementListApi, AssignByData, userData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [date, setdate] = useState(editData ? dateFormat(
        editData?.CreatedOn.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [previewUrl1, setPreviewUrl1] = useState('')
    const [previewUrl2, setPreviewUrl2] = useState('')
    const [previewUrl3, setPreviewUrl3] = useState('')
    const [previewUrl4, setPreviewUrl4] = useState('')
    const [userFilter, setUserFilter] = useState(0)

    useEffect(() => {
        if (editData && isEdit) {
            setPreviewUrl1(editData?.Image1)
            setPreviewUrl2(editData?.Image2)
            setPreviewUrl3(editData?.Image3)
            setPreviewUrl4(editData?.Image4)
            setdate(editData ? dateFormat(
                editData?.CreatedOn.split("T")[0],
                "dd-MM-yyyy"
            ) : dateFormat(
                new Date(),
                "dd-MM-yyyy"
            ))
        } else {
            setPreviewUrl1('')
            setPreviewUrl2('')
            setPreviewUrl3('')
            setPreviewUrl4('')
            setdate(dateFormat(new Date(), "dd-MM-yyyy"))
            setUserFilter(0)
        }
    }, [editData])

    // Requirement Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            OrderNo: editData ? editData.OrderNo : '',
            Name: editData ? editData.CreatedByName : '',
            Detail: editData ? editData?.Detail : '',
            Image1: "",
            Image2: "",
            Image3: "",
            Image4: "",
        },
        validationSchema: Yup.object({
            OrderNo: Yup.string().required("The Sr. No. is required"),
        }),
        onSubmit: values => {

            if (!isEdit && userFilter == 0) {
                toast.error("Please select a designer", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }
            setformSumitLoading(true)
            if (values) {
                const Image1 =
                    (values.Image1 == "" || values.Image1 == undefined)
                        ? previewUrl1
                        : values.Image1.split(",")[1]
                const Image2 =
                    (values.Image2 == "" || values.Image2 == undefined)
                        ? previewUrl2
                        : values.Image2.split(",")[1]
                const Image3 =
                    (values.Image3 == "" || values.Image3 == undefined)
                        ? previewUrl3
                        : values.Image3.split(",")[1]
                const Image4 =
                    (values.Image4 == "" || values.Image4 == undefined)
                        ? previewUrl4
                        : values.Image4.split(",")[1]

                if (isEdit) {
                    putApi("DrawRequirement/update", {
                        Id: editData.Id,
                        OrderNo: values.OrderNo,
                        Date: formatDateToISO(date),
                        Detail: values.Detail || '',
                        Image1: Image1 || '',
                        Image2: Image2 || '',
                        Image3: Image3 || '',
                        Image4: Image4 || '',
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            setdate(new Date())
                            if (DrawRequirementListApi != '') {
                                DrawRequirementListApi()
                            }
                            validation.handleReset()
                            setPreviewUrl1('')
                            setPreviewUrl2('')
                            setPreviewUrl3('')
                            setPreviewUrl4('')
                        }
                    })
                } else {
                    postApi("DrawRequirement/create", {
                        Id: 0,
                        DesignerBy: userFilter?.value,
                        OrderNo: values.OrderNo,
                        Date: formatDateToISO(date),
                        Detail: values.Detail || '',
                        Image1: Image1 || '',
                        Image2: Image2 || '',
                        Image3: Image3 || '',
                        Image4: Image4 || '',
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status = 200) {
                            toast.success("Successfully Created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            setdate(new Date())
                            if (DrawRequirementListApi != '') {
                                DrawRequirementListApi()
                            }
                            setPreviewUrl1('')
                            setPreviewUrl2('')
                            setPreviewUrl3('')
                            setPreviewUrl4('')
                            validation.handleReset()
                        } else {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        }
                    })
                }
            }
        },
    })

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop1 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl1(URL.createObjectURL(compressedResult))
                validation.setFieldValue("Image1", await toBase64(compressedResult))
            },
        })
    }
    const handleDrop2 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl2(URL.createObjectURL(compressedResult))
                validation.setFieldValue("Image2", await toBase64(compressedResult))
            },
        })
    }
    const handleDrop3 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl3(URL.createObjectURL(compressedResult))
                validation.setFieldValue("Image3", await toBase64(compressedResult))
            },
        })
    }
    const handleDrop4 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl4(URL.createObjectURL(compressedResult))
                validation.setFieldValue("Image4", await toBase64(compressedResult))
            },
        })
    }


    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "650px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Draw Requirement" : "Create Draw Requirement"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Order. No.
                                    </Label>
                                    <Input
                                        name="OrderNo"
                                        placeholder="Order. No"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.OrderNo}
                                        invalid={
                                            validation.touched.OrderNo && validation.errors.OrderNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.OrderNo && validation.errors.OrderNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.OrderNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                {isEdit ?
                                    <FormGroup className="mb-2">
                                        <Label htmlFor="validationCustom03" className="required">
                                            Designer
                                        </Label>
                                        <Input
                                            name="Name"
                                            disabled
                                            placeholder="Designer Name"
                                            type="text"
                                            className="form-control-sm"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.Name}
                                            invalid={
                                                validation.touched.Name && validation.errors.Name
                                                    ? true
                                                    : false
                                            }
                                        />
                                        {validation.touched.Name && validation.errors.Name ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.Name}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                    :
                                    <FormGroup className="mb-2">
                                        <Label htmlFor="validationCustom03" className="required">
                                            Designer
                                        </Label>
                                        <Select
                                            unstyled
                                            styles={colourStyles}
                                            value={userFilter}
                                            onChange={(e) => setUserFilter(e)}
                                            options={userData}
                                            className="select2-selection"
                                        />
                                    </FormGroup>
                                }
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={date}
                                                onChange={(e) => { setdate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className=''
                                    >
                                        Detail
                                    </Label>
                                    <Input
                                        name="Detail"
                                        placeholder="Detail"
                                        type="textarea"
                                        rows={3}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Detail}
                                        invalid={
                                            validation.touched.Detail && validation.errors.Detail
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Detail && validation.errors.Detail ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Detail}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop1}
                                        onClick={handleDrop1}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                {previewUrl1 ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="135px"
                                                                height="150px"
                                                                src={previewUrl1}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "135px",
                                                                height: "150px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.Image1 && validation.errors.Image1 ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Image1}
                                                    </FormFeedback>
                                                ) : null}
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop2}
                                        onClick={handleDrop2}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                {previewUrl2 ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="135px"
                                                                height="150px"
                                                                src={previewUrl2}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "135px",
                                                                height: "150px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.Image2 && validation.errors.Image2 ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Image2}
                                                    </FormFeedback>
                                                ) : null}
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop3}
                                        onClick={handleDrop3}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                {previewUrl3 ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="135px"
                                                                height="150px"
                                                                src={previewUrl3}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "135px",
                                                                height: "150px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.Image3 && validation.errors.Image3 ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Image3}
                                                    </FormFeedback>
                                                ) : null}
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop4}
                                        onClick={handleDrop4}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                {previewUrl4 ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="135px"
                                                                height="150px"
                                                                src={previewUrl2}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "135px",
                                                                height: "150px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.Image4 && validation.errors.Image4 ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Image4}
                                                    </FormFeedback>
                                                ) : null}
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>

                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                // type="reset"
                                onClick={() => toggle()}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default CreateUpdateDrawRequirementModel